import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";

import "./BankDetails.css";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import BankTranferDetailsSelect from "../../../../../Formik/BankDetailsSelect";
import { $api } from "../../../../../../../helpers/$api";

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
}));

const BankDetails = () => {
  const [banks, setBanks] = useState([]);
  const [isSubmitting, setSubmitting] = useState([]);
  const [payload, setPayload] = useState({ bank: "", account_number: "" });
  const classes = useStyles();

  const asyncData = useCallback(async () => {
    try {
      const banks = await $api.user.getBanks();

      setBanks(banks);
    } catch (error) {
      // error getting banks...
    }
  }, [setBanks]);

  const handleInput = (event) => {
    const { name, value } = event.target;

    setPayload({ ...payload, [name]: value });
  };

  const handleSubmit = async () => {
    try {
      if (!isSubmitting) {
        await $api.user.addBankAccount(payload);

        toast.success("bank added successfully!");
        setPayload({ bank: "", account_number: "" });
      }
    } catch (error) {
      toast.error(`error adding bank - ${error.message}`);
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    asyncData();
  }, [asyncData]);

  return (
    <div className="bank-section">
      <div className="bankDetails-header">
        <h1>Add Bank Account</h1>
        <p>Add a valid account details to get verified.</p>
      </div>
      <div className="bankInput">
        <input
          type="text"
          name="account_number"
          placeholder="Enter account number"
          className="bank-input"
          value={payload.account_number}
          onChange={handleInput}
        />

        <select
          name="bank"
          id=""
          onChange={handleInput}
          style={{
            marginTop: "10px",
          }}
        >
          <option value=""> Select bank</option>
          {banks.map((bank) => (
            <option key={bank.id} value={bank.name}>
              {bank.name}
            </option>
          ))}
        </select>

        <br />
        {/* <input
          type="text"
          placeholder="Select back"
          className="bank-input mt-5"
        /> */}
      </div>
      <div className="bank-btns">
        <Button
          type="submit"
          variant="contained"
          color="#"
          className={classes.button}
          style={{
            backgroundColor: "#0768F6",
            color: "white",
            width: "396px",
            height: "56px",
            textTransform: "capitalize",
            fontSize: "1.6rem",
            fontWeight: "500",
            lineHeight: "30px",
            borderRadius: "4px 4px 4px 0px",
            position: "relative",
            right: "8px",
            marginTop: "26px",
          }}
          onClick={handleSubmit}
        >
          Add Account
        </Button>
      </div>
    </div>
  );
};

export default BankDetails;
